// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"28":"558c4ce1a6379621abc3","138":"45312e5a079898090620","147":"06c2138c0a84b34e052c","251":"028e4f379cccfe80168a","352":"e80157301a74fb3572b2"}[chunkId] + ".js";
};